import React from 'react';

/** Swappable reveal-animation module. Timing is owned here, not by the flow. */
export type RevealAnimationStyle = 'wipe' | 'spin' | 'curtains' | 'vortex' | 'pixels';
const SparkleReveal: React.FC<{ paperUrl?: string; posterUrl?: string; title: string; style: RevealAnimationStyle }> = ({ paperUrl, posterUrl, title, style }) => (
  <div className={`cd-reveal-animation is-${style}`} aria-label={`Revealing ${title}`}>
    <div className="cd-reveal-tension" aria-hidden="true">
      <span>Get ready…</span><b>3</b><b>2</b><b>1</b>
      {style === 'vortex' && <strong>ABRACADABRA!</strong>}
    </div>
    {paperUrl ? <img className="cd-reveal-paper-out" src={paperUrl} alt="Student paper" /> : null}
    <div className="cd-reveal-sparkles" aria-hidden="true">
      {Array.from({ length: 18 }, (_, index) => <i key={index}>✦</i>)}
    </div>
    {style === 'curtains' && <><div className="cd-curtain left" /><div className="cd-curtain right" /><strong className="cd-reveal-callout">Drumroll please!</strong></>}
    {style === 'pixels' && <div className="cd-pixel-grid" aria-hidden="true">{Array.from({length: 64},(_,i)=><i key={i}/>)}</div>}
    {posterUrl ? <img className="cd-reveal-poster-in" src={posterUrl} alt={title} /> : (
      <div className="cd-reveal-poster-in cd-reveal-poster-fallback">{title}</div>
    )}
  </div>
);

export default SparkleReveal;
